module.exports = __webpack_public_path__ + "static/media/Tier_3.f1a56982.png";